import { useTranslation } from "react-i18next"
import { ErrorView } from "./ErrorView"
import { getProductName } from "@/utils/product-name"

export const SmallScreenErrorView = () => {
	const { t } = useTranslation("components")
	return (
		<ErrorView
			title={t("smallScreenErrorView.title")}
			description={t("smallScreenErrorView.isDesignedForDesktopAnd", {
				var0: getProductName(),
			})}
		/>
	)
}
